
import { defineComponent } from 'vue'
import Done from '@/components/Done.vue'

export default defineComponent({
  name: 'TileModal',
  data() {
    return {
      types: {
        gpu: 'gpu',
        ram: 'ram',
        hdd: 'hdd',
        cpu: 'cpu',
      },
    }
  },
  props: {
    done: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'cpu',
    },
    value: {
      type: Number,
      default: 2048,
    },
  },
  components: {
    'tp-done': Done,
  },
  computed: {
    classes(): any[] {
      let classes = ['tile__modal']

      if (this.done === true) {
        classes.push('tile__modal-done')
      } else {
        classes.push('tile__modal-hide')
      }

      return classes
    },
  },
  methods: {
    getColor(): string {
      let color = '#000'
      const type = this.type
      const value = this.value

      if (type === this.types.cpu) {
        if (value === 2) {
          color = '#B2BEC1'
        }

        if (value === 4) {
          color = '#B1D0DA'
        }

        if (value === 8) {
          color = '#A2D2E1'
        }

        if (value === 16) {
          color = '#8DD7EE'
        }

        if (value === 32) {
          color = '#75DEFF'
        }

        if (value === 64) {
          color = '#5FD8FF'
        }

        if (value === 128) {
          color = '#30CDFF'
        }

        if (value === 256) {
          color = '#25C7FA'
        }

        if (value === 512) {
          color = '#00C2FF'
        }

        if (value === 1024) {
          color = '#00C2FF'
        }

        if (value === 2048) {
          color = '#00C2FF'
        }
      }

      if (type === this.types.gpu) {
        if (value === 2) {
          color = '#B2C1B5'
        }

        if (value === 4) {
          color = '#B1DAB8'
        }

        if (value === 8) {
          color = '#A2E1AD'
        }

        if (value === 16) {
          color = '#8DEE9D'
        }

        if (value === 32) {
          color = '#75FF8C'
        }

        if (value === 64) {
          color = '#5FFF79'
        }

        if (value === 128) {
          color = '#30FF52'
        }

        if (value === 256) {
          color = '#25FA49'
        }

        if (value === 512) {
          color = '#00FF2A'
        }

        if (value === 1024) {
          color = '#00FF2A'
        }

        if (value === 2048) {
          color = '#00FF2A'
        }
      }

      if (type === this.types.ram) {
        if (value === 2) {
          color = '#B8B2C1'
        }

        if (value === 4) {
          color = '#C1B1DA'
        }

        if (value === 8) {
          color = '#BAA2E1'
        }

        if (value === 16) {
          color = '#B28DEE'
        }

        if (value === 32) {
          color = '#AA75FF'
        }

        if (value === 64) {
          color = '#9C5FFF'
        }

        if (value === 128) {
          color = '#7F30FF'
        }

        if (value === 256) {
          color = '#7725FA'
        }

        if (value === 512) {
          color = '#6200FF'
        }

        if (value === 1024) {
          color = '#6200FF'
        }

        if (value === 2048) {
          color = '#6200FF'
        }
      }

      if (type === this.types.hdd) {
        if (value === 2) {
          color = '#B2C1C0'
        }

        if (value === 4) {
          color = '#B1DAD7'
        }

        if (value === 8) {
          color = '#A2E1DD'
        }

        if (value === 16) {
          color = '#8DEEE8'
        }

        if (value === 32) {
          color = '#75FFF6'
        }

        if (value === 64) {
          color = '#5FFFF4'
        }

        if (value === 128) {
          color = '#5FFFF4'
        }

        if (value === 256) {
          color = '#25FAEC'
        }

        if (value === 512) {
          color = '#00FFEE'
        }

        if (value === 1024) {
          color = '#00FFEE'
        }

        if (value === 2048) {
          color = '#00FFEE'
        }
      }

      return color
    },
    isImageVisible(min: number, max: number, type: string): boolean {
      let isVisible = false
      let value = this.value || 0

      if (value > min && value <= max && this.type === type) {
        isVisible = true
      }

      return isVisible
    },
    tileImageClasses(value: number, type: string): any {
      let classes = ['tile__modal-image']
      let typeClass = 'tile__modal-image-'

      if (type === this.types.cpu) {
        typeClass = typeClass + 'cpu__'
      }

      if (type === this.types.ram) {
        typeClass = typeClass + 'ram__'
      }

      if (type === this.types.hdd) {
        typeClass = typeClass + 'hdd__'
      }

      if (type === this.types.gpu) {
        typeClass = typeClass + 'gpu__'
      }

      typeClass = typeClass + value.toString()
      classes.push(typeClass)

      return classes
    },
  },
})
